module.exports = __webpack_public_path__ + "fonts/AntykwaTorunska-Bold.9c737d5d.ttf";